jQuery(".firstimg").on("click", function() {
	jQuery('#imagemodal h4').html(jQuery(this).attr("data-title"));
   //jQuery('#imagepreview').attr('src', jQuery('#locandina').attr('src')); // here asign the image to the modal when the user click the enlarge link
  // jQuery('#imagepreview').attr('src', jQuery('#locandina').attr('srcset').split(',').pop().trim().split(' ')[0]);
  var image = jQuery(this).children('img').attr('srcset').split(',').pop().trim().split(' ')[0];
  var urlParts = image.split('?');
var params = new URLSearchParams(urlParts[1]);
params.delete('resize');
params.delete('w')
var newUrl = urlParts[0] + '?' + params.toString()
   jQuery('#imagepreview').attr('src', newUrl);
   jQuery('#imagemodal').modal('show'); // imagemodal is the id attribute assigned to the bootstrap modal, then i use the show function
});

var $videoSrc;  
jQuery('.firstvideo').click(function() {
    $videoSrc =jQuery(this).data( "src" );
});

jQuery('#videoModal').on('show.bs.modal', function () {     
    jQuery('#iframevideo').css('max-height', jQuery(window).height() * 0.8);
	jQuery("#iframevideo").attr('src',$videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0" ); 
});

jQuery(".firstvideo").on("click", function() {
	jQuery('#videoModal h4').html(jQuery(this).attr("data-title"));
   //jQuery('#imagepreview').attr('src', jQuery('#locandina').attr('src')); // here asign the image to the modal when the user click the enlarge link
   jQuery('#videoModal').modal('show'); // imagemodal is the id attribute assigned to the bootstrap modal, then i use the show function
});